import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import { lazyWithRetry } from './lazyWithRetry';

const WelcomePage = lazyWithRetry(() => import("../pages/WelcomePage"));
const PartnerSignup = lazyWithRetry(() => import("../pages/PartnerSignup"));
const Partners = lazyWithRetry(() => import("../pages/Partners"));
const Investors = lazyWithRetry(() => import("../pages/Investors"));
const PartnersCaseStudies = lazyWithRetry(() => import("../pages/PartnerCaseStudies"));
const AmbassadorRedirect = lazyWithRetry(() => import("../pages/AmbassadorRedirect"));
const PrivacyPolicy = lazyWithRetry(() => import("../pages/PrivacyPolicy"));
const TermsAndConditions = lazyWithRetry(() => import("../pages/TermsAndConditions"));
const PartnerAttendance = lazyWithRetry(() => import("../pages/PartnerAttendance"));
const UGCSignup = lazyWithRetry(() => import("../pages/UGCSignup"));
const UGCLanding = lazyWithRetry(() => import("../pages/UGCLanding"));
const UGCCreatorsMarketplace = lazyWithRetry(() => import("../pages/UGCCreatorsMarketplace"));
const BlogList = lazyWithRetry(() => import("../pages/BlogList"));
const BlogPost = lazyWithRetry(() => import("../pages/BlogPost"));
const FormRenderer = lazyWithRetry(() => import("../pages/FormRenderer"));

export const PublicRoutes = () => [
  <Route key="welcome" path="welcome" element={<WelcomePage />} />,
  <Route key="partner" path="partner" element={<Navigate to="/partners" />} />,
  <Route key="partner-signup" path="partner-signup" element={<PartnerSignup />} />,
  <Route key="partners" path="partners" element={<Partners />} />,
  <Route key="investors" path="investors" element={<Investors />} />,
  <Route key="partners-case-studies" path="partners/case-studies" element={<PartnersCaseStudies />} />,
  <Route key="r" path="r" element={<AmbassadorRedirect />} />,
  <Route key="ambassador-link" path="ambassador-link" element={<AmbassadorRedirect />} />,
  <Route key="privacy" path="privacy" element={<PrivacyPolicy />} />,
  <Route key="terms" path="terms" element={<TermsAndConditions />} />,
  <Route key="partner-attendance" path="partner/attendance/:token" element={<PartnerAttendance />} />,
  <Route key="ugc" path="ugc" element={<UGCLanding />} />,
  <Route key="ugc-creators" path="ugc/creators" element={<UGCCreatorsMarketplace />} />,
  <Route key="ugc-signup" path="ugc-signup" element={<UGCSignup />} />,
  <Route key="blog" path="blog" element={<BlogList />} />,
  <Route key="blog-post" path="blog/:slug" element={<BlogPost />} />,
  <Route key="form-renderer" path="forms/:slug" element={<FormRenderer />} />,
];